import React, { useMemo } from "react";
import { useData } from "../../context/DataContext";
import { useAuth } from "../../context/AuthContext";
import { userMatchesField, cellText } from "../../utils/helpers";
import TaskTable from "../../components/TaskTable";
import { USER_TABLE } from "../../context/DataContext";

export default function OverdueTasks() {
  const { userRecords, adminRecords, loading } = useData();
  const { user } = useAuth();

  // Build lookup: admin task fully done (all users completed)?
  const adminDoneMap = useMemo(() => {
    const m = {};
    for (const ar of adminRecords) {
      const tid = cellText(ar.fields?.["Task ID"]);
      if (!tid || tid === "—") continue;
      const st = cellText(ar.fields?.["Overall Status"]).toLowerCase();
      m[tid] = st.includes("done") || st.includes("✅");
    }
    return m;
  }, [adminRecords]);

  const overdue = useMemo(() =>
    userRecords.filter((r) => {
      const isMine = r.user_id === user?.userId;
      if (!isMine) return false;
      const end = r.fields?.["End Date"];
      const isPast = end && end < Date.now();
      const tid = cellText(r.fields?.["Task ID"]);
      // Overdue only if not fully done (all users completed)
      return isPast && !adminDoneMap[tid];
    }),
    [userRecords, user, adminDoneMap]
  );

  if (loading && userRecords.length === 0) return <div className="loading-box"><div className="spinner" /><span>Loading...</span></div>;

  return (
    <div className="fade-in">
      {overdue.length > 0 && (
        <div className="alert alert-error" style={{ marginBottom: 20 }}>
          ⚠ You have <strong>{overdue.length}</strong> overdue task{overdue.length > 1 ? "s" : ""}. Please take action immediately.
        </div>
      )}
      <TaskTable
        title="🔴 Overdue Tasks"
        tableId={USER_TABLE}
        records={overdue}
        emptyMsg="No overdue tasks. You're on track! 🎯"
        canComplete
        hideStatusFilter={true}
        kanbanLayout="overdueDate"
      />
    </div>
  );
}
